<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="topUsersFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#topUsersFilter">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="title">
                                                {{ $t('label.users_count') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    ref="count_of_users"
                                                    type="number"
                                                    name="count_of_users"
                                                    id="count_of_users"
                                                    v-model="query.count_of_users"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="title">
                                                {{ $t('label.days_count') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    ref="count_of_days"
                                                    type="number"
                                                    name="count_of_days"
                                                    id="count_of_days"
                                                    v-model="query.count_of_days"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="title">
                                                {{ $t('label.top_users_full_name') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    ref="user_name"
                                                    name="user_name"
                                                    id="user_name"
                                                    v-model="query.user_name"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>

export default {
    props: {
        action: {
            default: function (e, query) {
            },
            required: true,
        }
    },
    mounted() {
    },
    methods: {
    },
    data() {
        return {
            query: {
                count_of_users: 30,
                count_of_days: 10,
                user_name: '',
            },
        }
    }
}
</script>

<style>

</style>